// btw-front/src/components/admin/dashboard/SignupDetailModal.jsx
// [파트너 가입 신청] 신청 상세 팝업 — 회사/담당자 정보·첨부 다운로드·승인/반려 버튼
// props 는 SignupsTab 의 상태/핸들러 이름을 그대로 받는다(부모 식별자와 1:1).
import React from "react";
import { useTranslation } from "react-i18next";
import { Modal } from "antd";
import { SignupKindBadge, SignupKindHint } from "./SignupKindBadge";

export default function SignupDetailModal({
  acting,
  handleApprove,
  handleDownload,
  selected,
  setRejectOpen,
  setSelected,
}) {
  const { t } = useTranslation();
  return (
    <>
      <Modal
        title={t("admin.signup.detailTitle")}
        open={!!selected}
        onCancel={() => setSelected(null)}
        footer={
          selected && selected.status === "pending"
            ? [
                <button
                  key="reject"
                  onClick={() => setRejectOpen(true)}
                  disabled={acting}
                  className="btw-btn-ghost mr-2 disabled:opacity-60"
                >
                  {t("admin.signup.reject")}
                </button>,
                <button
                  key="approve"
                  onClick={handleApprove}
                  disabled={acting}
                  className="btw-btn-accent disabled:opacity-60"
                >
                  {t("admin.signup.approve")}
                </button>,
              ]
            : null
        }
      >
        {selected && (
          <div className="grid gap-2 text-sm">
            <div className="mb-2 flex flex-wrap items-center gap-2">
              <SignupKindBadge signup={selected} />
              {selected.hasBrochure && (
                <button
                  type="button"
                  onClick={() => handleDownload("brochure")}
                  className="text-xs text-accent underline-offset-2 hover:underline"
                >
                  {t("admin.signup.downloadBrochure")} ·{" "}
                  {selected.brochureOriginalName || t("admin.signup.brochureFallback")}
                </button>
              )}
              {selected.hasBusinessRegistration && (
                <button
                  type="button"
                  onClick={() => handleDownload("businessRegistration")}
                  className="text-xs text-accent underline-offset-2 hover:underline"
                >
                  {t("admin.signup.downloadBusinessRegistration")} ·{" "}
                  {selected.businessRegistrationOriginalName}
                </button>
              )}
              {selected.hasBankbook && (
                <button
                  type="button"
                  onClick={() => handleDownload("bankbook")}
                  className="text-xs text-accent underline-offset-2 hover:underline"
                >
                  {t("admin.signup.downloadBankbook")} · {selected.bankbookOriginalName}
                </button>
              )}
            </div>
            <SignupKindHint signup={selected} />
            <Row k={t("admin.signup.loginId")} v={selected.loginId || "-"} />
            <Row k={t("admin.signup.company")} v={selected.companyName} />
            <Row k={t("admin.signup.businessNumber")} v={selected.businessNumber} />
            <Row k={t("admin.signup.representativeName")} v={selected.representativeName || "-"} />
            <Row k={t("admin.signup.companyEmail")} v={selected.companyEmail || "-"} />
            <Row k={t("admin.signup.industry")} v={selected.industry || "-"} />
            <Row k={t("admin.signup.address")} v={selected.address || "-"} />
            <Row
              k={t("admin.signup.salesRepHeadcount")}
              v={selected.salesRepHeadcount != null ? `${selected.salesRepHeadcount} 명` : "-"}
            />
            <Row
              k={t("admin.signup.techSupportHeadcount")}
              v={
                selected.techSupportHeadcount != null ? `${selected.techSupportHeadcount} 명` : "-"
              }
            />
            <Row
              k={t("admin.signup.contact")}
              v={`${selected.contactName}${selected.contactTitle ? ` (${selected.contactTitle})` : ""}`}
            />
            <Row k={t("admin.signup.email")} v={selected.contactEmail} />
            <Row k={t("admin.signup.phone")} v={selected.contactPhone} />
            <Row
              k={t("admin.signup.termsService")}
              v={selected.termsServiceAgreedAt?.slice(0, 10)}
            />
            <Row
              k={t("admin.signup.privacyConsent")}
              v={selected.privacyConsentAgreedAt?.slice(0, 10)}
            />
            <Row
              k={t("admin.signup.marketing")}
              v={
                selected.marketingConsentAgreedAt
                  ? selected.marketingConsentAgreedAt.slice(0, 10)
                  : "-"
              }
            />
            {selected.status === "rejected" && (
              <Row k={t("admin.signup.rejectReasonLabel")} v={selected.rejectReason} />
            )}
          </div>
        )}
      </Modal>
    </>
  );
}

function Row({ k, v }) {
  return (
    <div className="flex justify-between gap-3 border-b border-slate-100 py-1.5 last:border-b-0">
      <span className="text-xs text-slate-500">{k}</span>
      <span className="text-right text-sm text-slate-800">{v}</span>
    </div>
  );
}
